import { render, staticRenderFns } from "./cModalOptica.vue?vue&type=template&id=c3b7c456"
import script from "./cModalOptica.vue?vue&type=script&lang=js"
export * from "./cModalOptica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports